import {
  BookOpen, ClipboardList, Zap, FileText, ClipboardCheck, Presentation,
  Layers, Languages, Download, ShieldCheck, Camera, Terminal, Cpu, MessagesSquare,
} from 'lucide-react';

export const HERO_LABELS = ['AI Lesson Planning', 'Assessment Creation', 'Education-Focused AI'];

export const CAPABILITIES = [
  { icon: Layers, title: 'Board-aligned', text: 'CBSE · ICSE · IGCSE · IB · State Boards' },
  { icon: Languages, title: 'Multilingual', text: 'English + 6 Indian languages' },
  { icon: Download, title: 'Ready to use', text: 'Export to DOCX, PDF and PPT' },
  { icon: ShieldCheck, title: 'Private by design', text: 'Data hosted in India' },
];

export const SHOWCASE = [
  {
    id: 'lesson-planning',
    tab: 'Lesson planning',
    title: 'Plan a full lesson from one goal.',
    points: ['Pick a teaching goal and scope', 'Lesson plan, summary, questionnaire, teaching flow', 'Full Lesson Kit in one batch'],
    img: '/product/lesson-plan-kit.webp',
    alt: 'ActanonEdu Plan-based Kit screen with teaching goals and documents to create',
  },
  {
    id: 'assessments',
    tab: 'Assessments',
    title: 'Tests, exams and homework in three steps.',
    points: ['Choose a task: test, exam, homework, debate and more', 'Add board, class, subject and chapter', 'Match your own paper format with a blueprint upload'],
    img: '/product/assessment-wizard.webp',
    alt: 'ActanonEdu Quick Task generator showing the three-step wizard and task types',
  },
  {
    id: 'resources',
    tab: 'Teaching resources',
    title: 'Every NCERT textbook, right inside the app.',
    points: ['Browse by class and subject', 'Read chapters without leaving ActanonEdu', 'International collections included'],
    img: '/product/ncert-library.webp',
    alt: 'ActanonEdu Library showing NCERT textbooks by class and subject',
  },
  {
    id: 'workflows',
    tab: 'Academic workflows',
    title: 'Schedules, substitutes and classes — handled.',
    points: ['Weekly teacher timetable', 'Leave and substitute tracking', 'Class-wise student records'],
    img: '/product/school-schedule.webp',
    alt: 'ActanonEdu teacher schedule with weekly periods and substitute status',
  },
];

export const BOSCO_FEATURES = [
  { icon: Cpu, title: 'The engine behind ActanonEdu', text: 'Every lesson plan, worksheet and paper on the platform is built by BOSCO.' },
  { icon: ShieldCheck, title: 'Guarded for education', text: 'Stays on academic topics. Built to be safe for students and educators.' },
  { icon: MessagesSquare, title: 'Ask Bosco', text: 'Your in-app co-pilot. Explain, summarise or create questions from any file.' },
  { icon: Camera, title: 'BOSCO Capture', badge: 'Elite · Beta', text: 'Photograph a textbook page. Get a lesson plan, worksheet or assessment kit.' },
  { icon: Terminal, title: 'BOSCO CLI', badge: 'Elite · Beta', text: 'A command-line studio for government exam practice questions.' },
];

export const BOSCO_WHY = ['Knows boards, classes and chapters', 'Declines off-topic requests', 'Answers are a teaching aid — you stay in charge'];

export const TOOLS = [
  { icon: BookOpen, name: 'Lesson Plans', summary: 'Objectives, timed activities, differentiation and homework.' },
  { icon: ClipboardList, name: 'Worksheets', summary: 'Printable, with answer keys and the difficulty mix you choose.' },
  { icon: Zap, name: 'Quizzes', summary: 'MCQ, true/false, fill-in and short answer in seconds.' },
  { icon: FileText, name: 'Question Papers', summary: 'Board-pattern sections with marks that always add up.' },
  { icon: ClipboardCheck, name: 'Assignments', summary: 'Project, research and practice formats with model answers.' },
  { icon: Presentation, name: 'Teaching Materials', summary: 'Slides, teaching flows and summaries for one chapter.' },
];

export const STEPS = [
  { title: 'Choose a task', text: 'Lesson plan, test, worksheet or kit.' },
  { title: 'Add context', text: 'Board, class, subject, chapter — or upload a file.' },
  { title: 'Review & generate', text: 'BOSCO builds it. You check it.' },
  { title: 'Download & teach', text: 'DOCX, PDF or PPT. Ready for class.' },
];

export const BOSCO_FAQ = [
  { q: 'What is BOSCO AI?', a: 'BOSCO is the education-focused AI engine inside ActanonEdu. It powers every generator, the Ask Bosco co-pilot, BOSCO Capture and BOSCO CLI.' },
  { q: 'Does BOSCO replace the teacher?', a: 'No. BOSCO prepares drafts and resources. Teachers review, edit and decide what reaches the classroom.' },
];
